export default "__VITE_PUBLIC_ASSET__e52c5dad__"